import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../redux/axios";

const initialState = {
  bulkBySenderSmsData: null,
  isBulkFetching: false,
  isBulkSuccess: false,
  isBulkError: false,
  errorBulkMessage: "",
};

export const sendBulkBySenderSms = createAsyncThunk(
  "sms/sendbulk",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth.user.accessToken;
      const response = await axios.post("/sms/sendbulkopt", udata, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${tokenStr}`,
        },
      });

      let data = response;

      if (response.status === 200) {
        return data.data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }

      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
)

export const bulkBySenderSmsSlice = createSlice({
  name: "sendBulk",
  initialState,
  reducers: {
    clearStateBulkBySenderSms: (state, { payload }) => {
      state.bulkBySenderSmsData = null;
      state.isBulkFetching = false;
      state.isBulkSuccess = false;
      state.isBulkError = false;
      state.errorBulkMessage = "";
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(sendBulkBySenderSms.fulfilled, (state, action) => {
        state.bulkBySenderSmsData = action.payload.data;
        state.isBulkFetching = false;
        state.isBulkSuccess = true;
      })
      .addCase(sendBulkBySenderSms.pending, (state) => {
        state.isBulkFetching = true;
      })
      .addCase(sendBulkBySenderSms.rejected, (state, action) => {
        state.isBulkFetching = false;
        state.isBulkError = true;
        state.errorBulkMessage = action.payload
          ? action.payload.message
          : "Internal error";
      })
  },
});

export const { clearStateBulkBySenderSms, clearStateBulkMediaUpload } =
  bulkBySenderSmsSlice.actions;

export function clearNormalFormState() {
  return async (dispatch) => {
    dispatch(clearStateBulkBySenderSms());
  };
}

export function clearBulkMediaUploadState() {
  return async (dispatch) => {
    dispatch(clearStateBulkMediaUpload());
  };
}

export const bulkBySenderSmsSelector = (state) => state.bulkBySender;

export default bulkBySenderSmsSlice.reducer;
